module.exports = __webpack_public_path__ + "img/wild_box_logo.5ff20200.png";